import { render } from "./ProcessBpmSignMethod.vue?vue&type=template&id=2be22422&scoped=true"
import script from "./ProcessBpmSignMethod.vue?vue&type=script&lang=js"
export * from "./ProcessBpmSignMethod.vue?vue&type=script&lang=js"

import "./ProcessBpmSignMethod.vue?vue&type=style&index=0&id=2be22422&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be22422"]])

export default __exports__